import { render } from "./ComponenteElecPreciosOMIE.vue?vue&type=template&id=3ee3bf43&scoped=true"
import script from "./ComponenteElecPreciosOMIE.vue?vue&type=script&lang=js"
export * from "./ComponenteElecPreciosOMIE.vue?vue&type=script&lang=js"

import "./ComponenteElecPreciosOMIE.vue?vue&type=style&index=0&id=3ee3bf43&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee3bf43"]])

export default __exports__